<app-state-section [state]="sectionState">
  <div class="container" *ngIf="form">
    <div class="flex align-center column">
      <div class="flex justify-space-between info-row full-width">
        <!-- shipment id -->
        <div class="flex column partial-width" [ngClass]="{ 'cell-no-data': !shipment.id }">
          <p>{{ "Shipments.ShipmentId" | translate }}:&nbsp;{{shipment.id}}</p>
        </div>
        <!-- customer -->
        <div class="flex column partial-width customer-field" [ngClass]="{ 'cell-no-data': !shipment.customer.title }">
          <p>{{ "Shipments.Customer" | translate }}:&nbsp;{{ shipment.customer.title}}</p>
        </div>
      </div>

      <form class="form-group form flex column justify-space-between" [formGroup]="form">
        <div
          style="width: 100%"
          formArrayName="deliveryNotes"
          *ngFor="
            let deliveryNoteForm of form.get('deliveryNotes')['controls'];
            let i = index
          "
        >
          <div [formGroupName]="i">
            <div class="full-width flex dn-wrapper">
              <div class="controls flex column full-width">
                <!-- delivery note number -->
                <div class="flex column">
                  <mat-label>{{"Placeholder.EnterDeliveryNoteID" | translate}}</mat-label>
                  <mat-form-field appearance="outline">
                    <input
                      [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                      matInput
                      type="text"
                      min="0"
                      [placeholder]="'Placeholder.EnterDeliveryNoteID' | translate"
                      formControlName="referenceNumber"
                      oninput="validity.valid||(value='')"
                    />
                  </mat-form-field>
                </div>

                <div>
                  <ng-container *ngIf="deliveryNoteForm.get('attachment').value?.id">
                    <div>
                      <div style="margin-bottom: 10px">
                        <label>{{"Shipments.DeliveryNote" | translate}}:&nbsp;</label>
                        <a [appMediaLink]="deliveryNoteForm.get('attachment').value?.id" class="align-middle" style="cursor:pointer">
                          <ng-container *ngFor="let type of mimeType | enumToArray">
                            <span *ngIf="type.value === deliveryNoteForm.get('attachment').value?.mimetype">
                              {{ "General.Note" | translate }}{{ "." + type.key }}
                            </span>
                          </ng-container>
                        </a>
                      </div>
                    </div>
                  </ng-container>
                  <!-- upload delivery note -->
                  <ng-container>
                    <app-uploader
                      *ngIf="RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker"
                      label="{{deliveryNoteForm.get('attachment').value?.url ? ('Shipments.UpdateDeliveryNote' |  translate)  :  ('Shipments.UploadDeliveryNote' | translate) }} ({{ i+1 }})"
                      fileDisplayName="Note"
                      formControlName="attachment"
                    >
                      <span error *ngIf="deliveryNoteForm.get('attachment').errors?.maxFileSize">
                        {{'ErrorMessages.InvalidFileSizeExceed'|translate:({size: deliveryNoteForm.get('attachment').errors?.maxFileSize.size })}}
                      </span>
                    </app-uploader>
                  </ng-container>
                </div>
              </div>

              <div
                class="remove-icon"
                *ngIf="i > 0 && (RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                (click)="onDeleteDNControls(i)"
              >
                <img src="../../../../../assets/images/remove.svg" />
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker" class="add-btn">
          <img src="../../../../../assets/images/add.svg" />
          <p (click)="addDNControls()">{{ "Buttons.AddMoreDeliveryNoteID" | translate }}</p>
        </div>

        <div class="flex justify-space-between label-row full-width" *grantAccess="RolesConstants.DELIVERY_NOTE_PRICES_AND_COSTS_VIEW">
          <div class="flex partial-width category-label">{{ "Shipments.CustomerPrice" | translate }}</div>
          <div class="flex partial-width category-label">{{ "Shipments.TransportationCost" | translate}}</div>
        </div>

        <div class="flex justify-space-between content-row full-width" *grantAccess="RolesConstants.DELIVERY_NOTE_PRICES_AND_COSTS_VIEW">
          <div class="flex column partial-width category-content">
            <!-- customer price -->
            <div class="flex column full-width">
              <mat-label class="flex justify-space-between">
                {{ "Shipments.Price" | translate }}
                <span
                  class="text-underline text-primary"
                  style="cursor: pointer"
                  *ngIf="showChangeButton && (RolesConstants.SHIPMENT_DELIVERY_NOTE_EDIT_PRICES | userRoleChecker) && (shipment.status === ShipmentStatus.GoodsDelivered)"
                  (click)="onChangCustomerPrice()"
                >
                  {{"AddShipment.Change" | translate}}
                </span>
              </mat-label>
              <mat-form-field appearance="outline">
                <input
                  [readonly]="((RolesConstants.SHIPMENT_DELIVERY_NOTE_EDIT_PRICES | userRoleChecker) && (shipment.status === ShipmentStatus.GoodsDelivered)) ? false : true"
                  matInput
                  type="number"
                  [placeholder]="'Placeholder.WriteTheValue' | translate"
                  formControlName="customerPrice"
                />
                <mat-error *ngIf=" form.invalid && form.get('customerPrice').touched && form.get('customerPrice').hasError('min')">
                  {{ "ErrorMessages.MinimumValue" | translate : ({value: 1}) }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- waiting charge price -->
            <div class="flex column full-width">
              <div class="flex full-width waiting-price">
                <div class="flex column days">
                  <mat-label>{{"Shipments.Day" | translate}}</mat-label>
                  <mat-form-field appearance="outline" class="form-control-full-width">
                    <mat-select
                      formControlName="waitingDays"
                      [placeholder]="'0'"
                      [disabled]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                    >
                      <mat-option *ngFor="let day of days" [value]="day">{{ day }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="flex column price">
                  <mat-label>{{ "Inputs.WaitingChargePerDay" | translate }}</mat-label>
                  <mat-form-field appearance="outline">
                    <input
                      [readonly]="true"
                      matInput
                      type="number"
                      [placeholder]="'Placeholder.WriteTheValue' | translate"
                      formControlName="customerWaitingChargePerDay"
                    />

                  </mat-form-field>
                </div>
              </div>
              <div class="mt-2 mb-3 small">
                <span class="text-400">{{ "Shipments.TotalWaitingCharge" | translate }} </span>
                <span>{{ (form.get('waitingDays').value * form.get('customerWaitingChargePerDay').value) | number: '1.0-2' }}</span>
              </div>
            </div>

            <div class="flex column full-width mb-4" formGroupName="waitingChargeProfAttachment">
              <app-uploader
                *ngIf="RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker"
                label="{{ ('sharedFeatures.deliveryNote.uploadWaitingCharge' |  translate) }}"
                [labelFont]="'small'"
                fileDisplayName="Waiting Charge Proof"
                formControlName="attachment"
              ></app-uploader>
            </div>

            <!-- return charge price -->
            <div class="flex column full-width">
              <mat-label>{{"Shipments.ReturnChargePrice" | translate}}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                  matInput
                  type="number"
                  [placeholder]="'Placeholder.WriteTheValue' | translate"
                  formControlName="customerReturnCharge"
                />
              </mat-form-field>
              <span class="price-error small" *ngIf=" +form.get('fleetReturnCharge').value > +form.get('customerReturnCharge').value">
                {{ "ErrorMessages.PriceMoreThanCost" | translate }}
              </span>

            </div>

            <!-- Multi Destination Charge Price -->
            <div class="flex column full-width">
              <mat-label>{{"Shipments.MultiDestinationChargePrice" | translate}}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                  matInput
                  type="number"
                  [placeholder]="'Placeholder.WriteTheValue' | translate"
                  formControlName="multiDestinationChargePrice"
                />
              </mat-form-field>
              <span class="price-error small" *ngIf=" +form.get('multiDestinationChargeCost').value > +form.get('multiDestinationChargePrice').value">
                {{ "ErrorMessages.PriceMoreThanCost" | translate }}
              </span>
            </div>

            <!-- weighting fine  price -->
            <div class="flex column full-width">
              <mat-label>{{"Shipments.WeightingFinePrice" | translate}}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                  matInput
                  type="number"
                  [placeholder]="'Placeholder.WriteTheValue' | translate"
                  formControlName="weightingFine"
                />
              </mat-form-field>
              <span class="price-error small" *ngIf=" +form.get('fleetWeightingFine').value > +form.get('weightingFine').value">
                {{ "ErrorMessages.PriceMoreThanCost" | translate }}
              </span>
            </div>

            <!-- clearance fees price -->
            <div class="flex column full-width">
              <mat-label>{{"Shipments.ClearanceFeesPrice" | translate}}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                  matInput
                  type="number"
                  [placeholder]="'Placeholder.WriteTheValue' | translate"
                  formControlName="customerClearanceFees"
                />
              </mat-form-field>
              <span class="price-error small" *ngIf=" +form.get('fleetClearanceFees').value > +form.get('customerClearanceFees').value">
                {{ "ErrorMessages.PriceMoreThanCost" | translate }}
              </span>
            </div>
          </div>

          <div class="flex column partial-width category-content">
            <!-- transportation cost -->
            <div class="flex column full-width">
              <mat-label>{{"Shipments.Cost" | translate}}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  [readonly]="((RolesConstants.SHIPMENT_DELIVERY_NOTE_EDIT_PRICES | userRoleChecker) && (shipment.status === ShipmentStatus.GoodsDelivered)) ? false : true"
                  matInput
                  type="number"
                  [placeholder]="'Placeholder.WriteTheValue' | translate"
                  formControlName="fleetPrice"
                />
              <mat-error *ngIf=" form.invalid && form.get('fleetPrice').touched && form.get('fleetPrice').hasError('min')">
                {{ "ErrorMessages.MinimumValue" | translate : ({value: 1}) }}
              </mat-error>
              </mat-form-field>
            </div>

            <!-- waiting charge cost -->
            <div class="flex column full-width">
              <mat-label>{{"Shipments.WaitingChargeCost" | translate}}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                  matInput
                  type="number"
                  [placeholder]="'Placeholder.WriteTheValue' | translate"
                  formControlName="fleetWaitingCharge"
                />
              </mat-form-field>
            </div>

            <!-- return charge cost -->
            <div class="flex column full-width">
              <mat-label>{{"Shipments.ReturnChargeCost" | translate}}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                  matInput
                  type="number"
                  [placeholder]="'Placeholder.WriteTheValue' | translate"
                  formControlName="fleetReturnCharge"
                />
              </mat-form-field>
              <span class="price-error small" *ngIf=" +form.get('fleetReturnCharge').value > +form.get('customerReturnCharge').value">
                {{ "ErrorMessages.PriceMoreThanCost" | translate }}
              </span>
            </div>

            <!-- Multi Destination Charge Cost -->
            <div class="flex column full-width">
              <mat-label>{{"Shipments.MultiDestinationChargeCost" | translate}}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                  matInput
                  type="number"
                  [placeholder]="'Placeholder.WriteTheValue' | translate"
                  formControlName="multiDestinationChargeCost"
                />
              </mat-form-field>
              <span class="price-error small" *ngIf=" +form.get('multiDestinationChargeCost').value > +form.get('multiDestinationChargePrice').value">
                {{ "ErrorMessages.PriceMoreThanCost" | translate }}
              </span>
            </div>

            <!-- weighting fine cost -->
            <div class="flex column full-width">
              <mat-label>{{"Shipments.WeightingFineCost" | translate}}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                  matInput
                  type="number"
                  [placeholder]="'Placeholder.WriteTheValue' | translate"
                  formControlName="fleetWeightingFine"
                />
              </mat-form-field>
              <span class="price-error small" *ngIf=" +form.get('fleetWeightingFine').value > +form.get('weightingFine').value">
                {{ "ErrorMessages.PriceMoreThanCost" | translate }}
              </span>
            </div>

            <!-- clearance fees cost -->
            <div class="flex column full-width">
              <mat-label>{{"Shipments.ClearanceFeesCost" | translate}}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
                  matInput
                  type="number"
                  [placeholder]="'Placeholder.WriteTheValue' | translate"
                  formControlName="fleetClearanceFees"
                />
              </mat-form-field>
              <span class="price-error small" *ngIf=" +form.get('fleetClearanceFees').value > +form.get('customerClearanceFees').value">
                {{ "ErrorMessages.PriceMoreThanCost" | translate }}
              </span>
            </div>
          </div>
        </div>

        <!-- advanced payment -->
        <div class="flex column" *grantAccess="RolesConstants.DELIVERY_NOTE_PRICES_AND_COSTS_VIEW">
          <mat-label>{{"Shipments.AdvancedPayment" | translate}}</mat-label>
          <mat-form-field appearance="outline">
            <input
              [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
              matInput
              type="number"
              min="0"
              step="0.01"
              [placeholder]="'Placeholder.WriteTheValue' | translate"
              formControlName="advancedPayment"
              oninput="validity.valid||(value='')"
            />
            <span matSuffix class="suffix"><app-icon name="saudi-riyal" size="xs"></app-icon></span>
          </mat-form-field>
        </div>

        <!-- damage -->
        <div class="flex column" *grantAccess="RolesConstants.DELIVERY_NOTE_PRICES_AND_COSTS_VIEW">
          <mat-label>{{"Shipments.Damage" | translate}}</mat-label>
          <mat-form-field appearance="outline">
            <input
              [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
              matInput
              type="number"
              min="0"
              step="0.01"
              [placeholder]="'Placeholder.WriteTheValue' | translate"
              formControlName="damageCost"
              oninput="validity.valid||(value='')"
            />
            <app-icon matSuffix class="suffix" name="saudi_riyal"></app-icon>
          </mat-form-field>
        </div>

        <!-- price comment -->
        <div class="flex column text-area" *ngIf="showReasonField">
          <mat-label class="asterisk-after">{{ "Inputs.PriceChangeReason" | translate }}</mat-label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              rows="4"
              cols="40"
              type="text"
              [placeholder]="'Placeholder.WriteReason' | translate"
              formControlName="priceComment"
            ></textarea>

            <mat-error *ngIf="form.invalid && form.get('priceComment').hasError('required')">
              {{ "ErrorMessages.Required" | translate }}
            </mat-error>

            <mat-error *ngIf="form.invalid && form.get('priceComment').touched && form.get('priceComment').hasError('whitespace')">
              {{ "ErrorMessages.InValidData" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- notes -->
        <div class="flex column text-area">
          <mat-label>{{"Inputs.Notes" | translate}}</mat-label>
          <mat-form-field appearance="outline">
            <textarea
              [readonly]="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)"
              matInput
              rows="6"
              cols="40"
              type="text"
              [placeholder]="'Placeholder.WriteNotes' | translate"
              formControlName="deliveryNoteComment"
            ></textarea>
          </mat-form-field>
        </div>
      </form>
    </div>
    <!-- buttons -->
    <div *ngIf="RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker" class="flex buttons-container justify-space-between full-width">
      <button class="button cancel" (click)="onCancelClicked()">{{'Buttons.Cancel' | translate}}</button>
      <button
        class="button save"
        (click)="onSaveClicked()"
        [disabled]="form.invalid ||  (+form.get('fleetClearanceFees').value > +form.get('customerClearanceFees').value)
        ||  (+form.get('fleetWeightingFine').value > +form.get('weightingFine').value)
        || (+form.get('fleetReturnCharge').value > +form.get('customerReturnCharge').value)
        || (+form.get('multiDestinationChargeCost').value > +form.get('multiDestinationChargePrice').value)
        || (shipment.customerPriceType === CustomerPriceType.CONTRACTED && ((!form.get('priceComment')?.value && showReasonField) || !form.get('customerPrice')?.value || form.get('customerPrice')?.value == 0))
        "
      >
        {{'Buttons.Save' | translate}}
      </button>
    </div>

    <div *ngIf="!(RolesConstants.SHIPMENT_DELIVERY_NOTE_ADD_EDIT | userRoleChecker)" class="flex buttons-container justify-space-between full-width">
      <button class="button" style="width: 100%" (click)="onCancelClicked()">{{'Buttons.Close' | translate}}</button>
    </div>
  </div>
</app-state-section>
